import { ArrowUpRightIcon, ExternalLink } from "lucide-react";
import React from "react";

const MetaDataCard = ({ jobDetails }) => {
  const formatDate = (val) => {
    const date = new Date(val);

    const formatted = date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

    return formatted;
  };

  const handleViewJd = () => {
    window.open(jobDetails?.jdUrl, "_blank");
  };
  return (
    <div className="mt-[.65rem] grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div className="bg-[#FCFCFD] hover:scale-[1.035] transition-all duration-200 px-6 shadow-sm py-[.8rem] rounded-[8px] border border-[#D0D5DD] flex gap-[1.15rem] items-center">
        <div className="bg-[#FFFAEB] rounded-[8px] p-[.7rem] border border-[#EAECF0]">
          <svg
            width="25"
            height="25"
            viewBox="0 0 26 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M24.3333 22V19.6667C24.3333 17.4922 22.8461 15.6651 20.8333 15.147M16.75 1.33922C18.4602 2.0315 19.6667 3.7082 19.6667 5.66667C19.6667 7.62514 18.4602 9.30183 16.75 9.99411M18.5 22C18.5 19.8256 18.5 18.7384 18.1448 17.8808C17.6711 16.7373 16.7627 15.8289 15.6192 15.3552C14.7616 15 13.6744 15 11.5 15H8C5.82561 15 4.73841 15 3.88081 15.3552C2.73735 15.8289 1.82887 16.7373 1.35523 17.8808C1 18.7384 1 19.8256 1 22M14.4167 5.66667C14.4167 8.244 12.3273 10.3333 9.75 10.3333C7.17267 10.3333 5.08333 8.244 5.08333 5.66667C5.08333 3.08934 7.17267 1 9.75 1C12.3273 1 14.4167 3.08934 14.4167 5.66667Z"
              stroke="#DEA915"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div>
          <div className="text-[.8rem] text-[#667085] font-medium">
            Total Students
          </div>
          <div className="text-[1.3rem] text-[#101828] font-semibold">
            {jobDetails?.totalCandidateCount ?? "N/A"}
          </div>
        </div>
      </div>
      <div className="bg-[#FCFCFD] hover:scale-[1.035] transition-all duration-200 px-5 shadow-sm py-[.8rem] rounded-[8px] border border-[#D0D5DD] flex gap-[1.15rem] items-center">
        <div className="bg-[#FFFAEB] rounded-[8px] p-[.7rem] border border-[#EAECF0]">
          <svg
            width="25"
            height="25"
            viewBox="0 0 29 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.9966 18.0001H9.59664C7.36012 18.0001 6.24186 18.0001 5.35976 18.3655C4.18363 18.8526 3.24919 19.7871 2.76202 20.9632C2.39664 21.8453 2.39844 23.6634 2.39844 25.8999M18.5966 3.94901C20.3557 4.66107 21.5966 6.38567 21.5966 8.4001C21.5966 10.4145 20.3557 12.1391 18.5966 12.8512M16.1966 8.4001C16.1966 11.0511 14.0476 13.2001 11.3966 13.2001C8.74568 13.2001 6.59664 11.0511 6.59664 8.4001C6.59664 5.74913 8.74568 3.6001 11.3966 3.6001C14.0476 3.6001 16.1966 5.74913 16.1966 8.4001Z"
              stroke="#DEA915"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <g clip-path="url(#clip0_2297_20775)">
              <path
                d="M22.3984 19.1001C22.3984 18.6351 22.3984 18.4026 22.3473 18.2119C22.2086 17.6942 21.8043 17.2899 21.2867 17.1512C21.0959 17.1001 20.8634 17.1001 20.3984 17.1001C19.9335 17.1001 19.701 17.1001 19.5102 17.1512C18.9926 17.2899 18.5882 17.6942 18.4495 18.2119C18.3984 18.4026 18.3984 18.6351 18.3984 19.1001M16.9984 26.1001H23.7984C24.3585 26.1001 24.6385 26.1001 24.8524 25.9911C25.0406 25.8952 25.1936 25.7423 25.2894 25.5541C25.3984 25.3402 25.3984 25.0602 25.3984 24.5001V20.7001C25.3984 20.14 25.3984 19.86 25.2894 19.6461C25.1936 19.4579 25.0406 19.305 24.8524 19.2091C24.6385 19.1001 24.3585 19.1001 23.7984 19.1001H16.9984C16.4384 19.1001 16.1584 19.1001 15.9444 19.2091C15.7563 19.305 15.6033 19.4579 15.5074 19.6461C15.3984 19.86 15.3984 20.14 15.3984 20.7001V24.5001C15.3984 25.0602 15.3984 25.3402 15.5074 25.5541C15.6033 25.7423 15.7563 25.8952 15.9444 25.9911C16.1584 26.1001 16.4384 26.1001 16.9984 26.1001Z"
                stroke="#DEA915"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2297_20775">
                <rect
                  width="12"
                  height="12"
                  fill="white"
                  transform="translate(14.3984 15.6001)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div>
          <div className="text-[.8rem] text-[#667085] font-medium">
            Total Batches
          </div>
          <div className="text-[1.3rem] text-[#101828] font-semibold">
            {jobDetails?.totalBatchCount ?? "N/A"}
          </div>
        </div>
      </div>
      <div className="bg-[#FCFCFD] hover:scale-[1.035] transition-all duration-200 px-5 shadow-sm py-[.9rem] rounded-[8px] border border-[#D0D5DD] flex gap-[1.15rem] items-center">
        <div className="bg-[#FFFAEB] rounded-[8px] p-[.7rem] border border-[#EAECF0]">
          <svg
            width="25"
            height="25"
            viewBox="0 0 21 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.6667 1.31445V6.13342C12.6667 6.78681 12.6667 7.11351 12.7938 7.36307C12.9057 7.58259 13.0842 7.76107 13.3037 7.87292C13.5532 8.00008 13.8799 8.00008 14.5333 8.00008H19.3523M15 13.8333H5.66667M15 18.5H5.66667M8 9.16667H5.66667M12.6667 1H6.6C4.63982 1 3.65972 1 2.91103 1.38148C2.25247 1.71703 1.71703 2.25247 1.38148 2.91103C1 3.65972 1 4.63982 1 6.6V18.7333C1 20.6935 1 21.6736 1.38148 22.4223C1.71703 23.0809 2.25247 23.6163 2.91103 23.9519C3.65972 24.3333 4.63982 24.3333 6.6 24.3333H14.0667C16.0269 24.3333 17.0069 24.3333 17.7556 23.9519C18.4142 23.6163 18.9496 23.0809 19.2852 22.4223C19.6667 21.6736 19.6667 20.6935 19.6667 18.7333V8L12.6667 1Z"
              stroke="#DEA915"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div className="flex-1">
          <div className="text-sm text-[#101828] font-semibold break-all">
            {jobDetails?.jobTitle ?? "N/A"}
          </div>
          <div className="text-[.8rem]  text-[#667085] mt-[.1rem] break-all">
            {jobDetails?.jobLocation ?? "Location N/A"}
          </div>
          <div className="text-[.8rem]  text-[#667085] mt-[.1rem] flex justify-between items-center flex-wrap gap-y-2 gap-x-3">
            Created on{" "}
            {jobDetails?.creationTime
              ? formatDate(jobDetails?.creationTime)
              : "N/A"}
            <span
              className="ml-auto flex items-center hover-effect gap-1 text-amber-600 font-semibold hover:text-amber-500 text-[.8rem] cursor-pointer"
              onClick={() => handleViewJd()}
            >
              View JD
              <ArrowUpRightIcon
                className="hover:text-amber-500"
                size={19}
                strokeWidth={2.2}
                color="currentColor"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetaDataCard;
